(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8112],{

/***/ 4322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2676);


// interface AppContainerProps {
//   children: React.ReactNode;
// }
var AppContainer = function AppContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
    className: "flex min-h-screen items-center justify-center bg-[var(--side-bg-color)]",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      className: "flex min-h-screen w-screen max-w-app flex-col items-center justify-center bg-background text-fontBackground",
      children: children
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (AppContainer);

/***/ }),

/***/ 2114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Basket; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2893);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(4697);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(3197);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(5126);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(1233);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(286);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(6792);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2175);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(1260);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/router.js
var router = __webpack_require__(7048);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(5271);
// EXTERNAL MODULE: ./services/frontend/pricing.service.js
var pricing_service = __webpack_require__(3726);
// EXTERNAL MODULE: ./services/helper.js + 23 modules
var helper = __webpack_require__(1220);
// EXTERNAL MODULE: ./utils/analytics.js
var analytics = __webpack_require__(8120);
// EXTERNAL MODULE: ./utils/analyticsConfig.js
var analyticsConfig = __webpack_require__(1015);
// EXTERNAL MODULE: ./components/Loader.jsx
var Loader = __webpack_require__(4196);
// EXTERNAL MODULE: ./components/Navbar/CartIconSvg.jsx
var CartIconSvg = __webpack_require__(9574);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(7007);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/image.js
var next_image = __webpack_require__(7191);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@5.7.0_react@18.3.1/node_modules/react-icons/go/index.mjs
var go = __webpack_require__(5633);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@5.7.0_react@18.3.1/node_modules/react-icons/tb/index.mjs
var tb = __webpack_require__(7527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-loader-spinner@4.0.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-loader-spinner/dist/index.js
var dist = __webpack_require__(4162);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-loader-spinner@4.0.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-loader-spinner/dist/loader/css/react-spinner-loader.css
var react_spinner_loader = __webpack_require__(9330);
// EXTERNAL MODULE: ./lib/cdn.js
var cdn = __webpack_require__(351);
// EXTERNAL MODULE: ./lib/media.js
var media = __webpack_require__(1485);
// EXTERNAL MODULE: ./components/Picture.jsx
var Picture = __webpack_require__(8122);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2676);
;// CONCATENATED MODULE: ./components/Cart/BagItem.js













var BagItem = function BagItem(_ref) {
  var item = _ref.item,
      removeProductFromCart = _ref.removeProductFromCart,
      updateProductCount = _ref.updateProductCount;

  var _useState = (0,react.useState)(item.quantity || 1),
      count = _useState[0],
      setCount = _useState[1];

  var _useState2 = (0,react.useState)(0),
      availableStock = _useState2[0],
      setAvailableStock = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      mounted = _useState3[0],
      setMounted = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isRemoving = _useState4[0],
      setIsRemoving = _useState4[1];

  var specLine = [].concat((0,toConsumableArray/* default */.Z)((item.customFields || []).map(function (ca) {
    return String(ca.value);
  })), [item.size]).filter(Boolean).join(" · ");
  (0,react.useEffect)(function () {
    setMounted(true);
  }, []);
  (0,react.useEffect)(function () {
    updateProductCount(item.id, item.size, count);

    if (item.size) {
      var option = findProductStockAndPrice(item.size, item);
      setAvailableStock(typeof (option === null || option === void 0 ? void 0 : option.quantity) === "number" ? option.quantity : 0);
    } else {
      setAvailableStock(typeof item.availableQuantity === "number" ? item.availableQuantity : 0);
    }
  }, [count]);
  (0,react.useEffect)(function () {
    var _item$fields, _item$fields$OtherPh;

    if (mounted && item !== null && item !== void 0 && (_item$fields = item.fields) !== null && _item$fields !== void 0 && (_item$fields$OtherPh = _item$fields["Other photos"]) !== null && _item$fields$OtherPh !== void 0 && _item$fields$OtherPh.length) {
      localStorage.clear();
      window.location.reload();
    }
  }, [mounted, item]);

  var findProductStockAndPrice = function findProductStockAndPrice(size, product) {
    if (!size) {
      size = "-";
    }

    return (product.options || []).find(function (option) {
      return option.title === size;
    });
  };

  var photos = (item === null || item === void 0 ? void 0 : item.photos) || [];
  var photo = photos[0];
  var originalPhoto = typeof photo === "string" ? photo : photo === null || photo === void 0 ? void 0 : photo.src;
  var photoV2 = typeof photo === "object" ? photo : null;
  var newPhoto = originalPhoto ? (0,cdn/* toCdnUrl */.V$)(originalPhoto) : "";
  var fallBackPhoto = originalPhoto;
  var resolved = (0,media/* resolveImage */.rs)(originalPhoto, photoV2, "cart");

  if (!mounted) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "relative",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex items-start gap-4 ".concat(isRemoving ? "pointer-events-none opacity-60" : ""),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative h-[70px] w-[70px] shrink-0 overflow-hidden rounded-lg border border-[#ECEFF1]",
        children: [resolved.isV2 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, {
          resolved: resolved,
          alt: "Order name",
          width: 70,
          height: 70,
          imgClassName: "h-full w-full object-cover"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: newPhoto,
          unoptimized: true,
          height: 70,
          width: 70,
          alt: "Order name",
          className: "h-full w-full object-cover",
          onError: function onError(e) {
            e.target.src = fallBackPhoto;
          }
        }), item.colour ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "absolute right-[-1px] top-[-1px] z-[999] h-3 w-3 rounded-full",
          style: {
            backgroundColor: item.colour
          }
        }) : null]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "min-w-0 flex-1",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex items-start gap-[27px]",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "min-w-0 flex-1 text-[14px] font-medium text-checkoutText",
            children: item.title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "shrink-0 text-right text-[14px] font-medium text-checkoutText",
            children: "".concat(String.fromCharCode(0x20b9)).concat(count * item.salePrice)
          })]
        }), specLine ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-1 text-[12px] font-normal text-[#4B5563]",
          children: specLine
        }) : null, /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mt-2 flex items-center gap-x-4 text-[14px] font-medium",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "button",
            onClick: function onClick() {
              if (isRemoving) return;

              if (count < 2) {
                setIsRemoving(true);
                removeProductFromCart(item.id)();
                return;
              }

              setCount(count - 1);
            },
            "aria-label": "Decrement quantity",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(tb/* TbMinus */.ffR, {
              size: 16
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: count
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "button",
            onClick: function onClick() {
              if (isRemoving) return;

              if (count < availableStock) {
                setCount(count + 1);
              }
            },
            "aria-label": "Increment quantity",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(go/* GoPlus */.ueT, {
              size: 16
            })
          })]
        })]
      })]
    }), isRemoving ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute inset-0 z-10 flex items-center justify-center",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
        type: "Oval",
        color: "#ccc",
        height: 28,
        width: 28
      })
    }) : null]
  });
};

/* harmony default export */ var Cart_BagItem = (BagItem);
;// CONCATENATED MODULE: ./components/Cart/Basket.jsx









var _excluded = ["store"];


function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }














var Basket = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(Basket, _React$Component);

  var _super = _createSuper(Basket);

  function Basket(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Basket);

    _this = _super.call(this, props);

    (0,defineProperty["default"])((0,assertThisInitialized/* default */.Z)(_this), "handleWindowResize", function () {
      var _window$visualViewpor, _window$visualViewpor2;

      var height = (_window$visualViewpor = (_window$visualViewpor2 = window.visualViewport) === null || _window$visualViewpor2 === void 0 ? void 0 : _window$visualViewpor2.height) !== null && _window$visualViewpor !== void 0 ? _window$visualViewpor : window.innerHeight;
      document.documentElement.style.setProperty("--vh", "".concat(height * 0.01, "px"));
    });

    (0,defineProperty["default"])((0,assertThisInitialized/* default */.Z)(_this), "removeProductFromCart", function (productId) {
      return function () {
        var cartData = _this.props.cartData;
        var filteredProducts = cartData.products.filter(function (product) {
          return product.id !== productId;
        });

        if (filteredProducts.length === 0) {
          if (!_this.props.fromProductPage) _this.props.setRefresh();
        }

        var timerId = setTimeout(function () {
          cartData.products = filteredProducts;

          if (_this.props.fromProductPage) {
            _this.props.setCart(cartData, true);
          } else {
            _this.props.setCart(cartData);
          }

          _this.setState({
            refresh: !_this.state.refresh
          });

          if (_this.props.updateAddedToCart) {
            _this.props.updateAddedToCart(productId, false);
          }
        }, 300);
        _this.removeTimer = timerId;
      };
    });

    (0,defineProperty["default"])((0,assertThisInitialized/* default */.Z)(_this), "updateProductCount", function (productId, variant, count) {
      var cartData = _this.props.cartData;
      var productIndex = cartData.products.findIndex(function (product) {
        return product.id === productId && product.size === variant;
      });
      if (productIndex < 0) return;
      cartData.products[productIndex].quantity = count;

      _this.props.setCart(cartData);

      _this.setState({
        refresh: !_this.state.refresh
      });
    });

    _this.state = {
      loading: false,
      refresh: false,
      pageHeight: 0,
      newBottom: false,
      isStockAvailable: false
    };
    return _this;
  }

  (0,createClass/* default */.Z)(Basket, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _window$visualViewpor3,
          _window$visualViewpor4,
          _this2 = this;

      this._isBasketMounted = true;
      this.setState({
        pageHeight: window.innerHeight
      });
      window.addEventListener("resize", this.handleWindowResize, true);
      (_window$visualViewpor3 = window.visualViewport) === null || _window$visualViewpor3 === void 0 ? void 0 : _window$visualViewpor3.addEventListener("resize", this.handleWindowResize);
      (_window$visualViewpor4 = window.visualViewport) === null || _window$visualViewpor4 === void 0 ? void 0 : _window$visualViewpor4.addEventListener("scroll", this.handleWindowResize);
      this.handleWindowResize();
      (0,helper/* getStockAvailability */.gb)(this.props.cartData.products).then(function (isStockAvailable) {
        if (_this2._isBasketMounted) {
          _this2.setState({
            isStockAvailable: isStockAvailable
          });
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _window$visualViewpor5, _window$visualViewpor6;

      this._isBasketMounted = false;

      if (this.removeTimer) {
        clearTimeout(this.removeTimer);
      }

      window.removeEventListener("resize", this.handleWindowResize, true);
      (_window$visualViewpor5 = window.visualViewport) === null || _window$visualViewpor5 === void 0 ? void 0 : _window$visualViewpor5.removeEventListener("resize", this.handleWindowResize);
      (_window$visualViewpor6 = window.visualViewport) === null || _window$visualViewpor6 === void 0 ? void 0 : _window$visualViewpor6.removeEventListener("scroll", this.handleWindowResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$store,
          _this$props$store2,
          _this3 = this;

      var _getPrice = (0,pricing_service/* getPrice */.a)({
        shippingCharge: 0
      }, this.props.cartData, null, false),
          productTotalPrice = _getPrice.productTotalPrice;

      var price = (0,pricing_service/* truncateTo2Decimals */.w)(productTotalPrice);
      var isEmpty = !this.props.cartData.products.length;
      var isCheckoutDisabled = Boolean((_this$props$store = this.props.store) === null || _this$props$store === void 0 ? void 0 : _this$props$store.checkout) || isEmpty;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("aside", {
        className: "fixed left-1/2 top-0 z-[101] m-0 flex h-screen w-full max-w-app flex-col overflow-hidden bg-background font-montserrat text-fontBackground transition-transform duration-500 ease-in-out ".concat(this.props.isBasketOpen ? "-translate-x-1/2 opacity-100" : "pointer-events-none translate-x-[50vw] opacity-0"),
        style: {
          height: "calc(var(--vh, 1vh) * 100)"
        },
        children: [this.state.loading && /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative z-10 shrink-0 bg-background",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
            className: "relative mx-5 mt-8 flex items-center text-[20px] font-semibold text-checkoutText",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: (_this$props$store2 = this.props.store) === null || _this$props$store2 === void 0 ? void 0 : _this$props$store2.name
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              className: "absolute right-0 z-50 -mr-3 flex h-[38px] w-[38px] items-center justify-center border-none bg-transparent",
              onClick: function onClick() {
                return _this3.props.handleShowCart(!_this3.props.isBasketOpen);
              },
              "aria-label": "Close cart",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CartIconSvg/* default */.Z, {
                filled: !isEmpty
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "via-background/40 pointer-events-none absolute inset-x-0 top-full h-8 bg-gradient-to-b from-background from-[20%] to-transparent",
            "aria-hidden": "true"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "hide-scrollbar min-h-0 flex-1 overflow-y-auto px-5 pb-24",
          children: isEmpty ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mt-6 text-[16px] font-normal text-checkoutText",
            children: "Your cart seems to be empty."
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-6 flex w-full flex-col gap-y-5",
            children: this.props.cartData.products.map(function (product) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Cart_BagItem, {
                item: product,
                removeProductFromCart: _this3.removeProductFromCart,
                updateProductCount: _this3.updateProductCount
              }, "".concat(product.id, "-").concat(product.size || ""));
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative shrink-0",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "via-background/40 pointer-events-none absolute inset-x-0 bottom-full h-24 bg-gradient-to-t from-background from-[20%] to-transparent",
            "aria-hidden": "true"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: "flex w-full items-center border-none bg-[var(--theme-action-fill)] px-5 py-6 text-[13px] font-semibold text-[var(--theme-action-text)] outline-none ".concat(isEmpty ? "justify-center" : "justify-between"),
            style: {
              opacity: isEmpty ? 1 : isCheckoutDisabled ? 0.2 : 1,
              paddingBottom: "calc(1.5rem + env(safe-area-inset-bottom, 0px))"
            },
            disabled: !isEmpty && isCheckoutDisabled,
            onClick: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
              var _this3$props, _this3$props$store;

              var productsWithoutStore;
              return regenerator_default().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (!isEmpty) {
                        _context.next = 3;
                        break;
                      }

                      _this3.props.handleShowCart(false);

                      return _context.abrupt("return");

                    case 3:
                      productsWithoutStore = _this3.props.cartData.products.map(function (_ref2) {
                        var store = _ref2.store,
                            productWithoutStore = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

                        return productWithoutStore;
                      });
                      (0,analytics.trackEvent)(analyticsConfig.EVENTS.CHECKOUT_STARTED, {
                        subdomain: (_this3$props = _this3.props) === null || _this3$props === void 0 ? void 0 : (_this3$props$store = _this3$props.store) === null || _this3$props$store === void 0 ? void 0 : _this3$props$store.username,
                        cart_data: productsWithoutStore
                      });
                      router_default().push("/checkout");

                    case 6:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            })),
            children: isEmpty ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Continue Shopping"
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "Proceed to Checkout"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                children: ["\u20B9", price]
              })]
            })
          })]
        })]
      });
    }
  }]);

  return Basket;
}(react.Component);



/***/ }),

/***/ 8050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(7007);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/link.js
var next_link = __webpack_require__(153);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./contexts/StoreDataContext.js + 1 modules
var StoreDataContext = __webpack_require__(7222);
// EXTERNAL MODULE: ./hooks/useStorefrontLegal.js
var useStorefrontLegal = __webpack_require__(2797);
// EXTERNAL MODULE: ./lib/media.js
var media = __webpack_require__(1485);
// EXTERNAL MODULE: ./components/Picture.jsx
var Picture = __webpack_require__(8122);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2175);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2676);
;// CONCATENATED MODULE: ./components/Footer/BackToTopSvg.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var BackToTopSvg = function BackToTopSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "15",
    height: "18",
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M8.38672 3C8.38672 2.44772 7.939 2 7.38672 2C6.83443 2 6.38672 2.44772 6.38672 3V17C6.38672 17.5523 6.83443 18 7.38672 18C7.939 18 8.38672 17.5523 8.38672 17V3Z",
      fill: "#1A1A1A"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M12.758 7.379L7.378 2L2 7.379",
      stroke: "#1A1A1A",
      strokeWidth: "2",
      strokeLinecap: "round"
    })]
  }));
};

/* harmony default export */ var Footer_BackToTopSvg = (BackToTopSvg);
;// CONCATENATED MODULE: ./components/Footer/FeaturedFooter.jsx









var LEGAL_LINKS = [{
  href: "/privacy-policy",
  label: "Privacy",
  field: "policy"
}, {
  href: "/shipping-policy",
  label: "Shipping & Returns",
  field: "returns"
}, {
  href: "/terms-and-conditions",
  label: "Terms & Conditions",
  field: "terms"
}];

var FeaturedFooter = function FeaturedFooter() {
  var context = (0,StoreDataContext/* useStoreContext */.Q)();
  var storeData = context === null || context === void 0 ? void 0 : context.storeData;

  var _useStorefrontLegal = (0,useStorefrontLegal/* default */.Z)(Boolean(storeData)),
      legalInfo = _useStorefrontLegal.data;

  var footerLinks = [{
    href: "/contact",
    label: "Info"
  }].concat((0,toConsumableArray/* default */.Z)(LEGAL_LINKS.filter(function (_ref) {
    var field = _ref.field;
    return (legalInfo === null || legalInfo === void 0 ? void 0 : legalInfo[field]) != null && String(legalInfo[field]).trim() !== "";
  })));
  var logo = storeData === null || storeData === void 0 ? void 0 : storeData.logo;
  var rawLogo = typeof logo === "string" ? logo : (logo === null || logo === void 0 ? void 0 : logo.src) || "";
  var logoSrc = rawLogo.startsWith("//") ? "https:".concat(rawLogo) : rawLogo;
  var resolved = (0,media/* resolveImage */.rs)(logoSrc, typeof logo === "object" ? logo : null, "logo");
  var instagramHandle = ((storeData === null || storeData === void 0 ? void 0 : storeData.social) || "").trim().replace(/^@/, "");

  var scrollToTop = function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("footer", {
    className: "mb-11 mt-[60px] w-full font-montserrat text-checkoutText",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "px-5",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "h-px bg-[#E8E5DC]"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "px-5 pt-8",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center",
        children: [logoSrc ? /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            "aria-label": "Home",
            className: "block h-[70px] w-[70px] overflow-hidden rounded-full",
            children: resolved.isV2 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, {
              resolved: resolved,
              alt: "",
              width: 70,
              height: 70,
              imgClassName: "h-full w-full object-cover"
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: resolved.src,
              alt: "",
              width: 70,
              height: 70,
              className: "h-full w-full object-cover",
              onError: function onError(e) {
                if (e.currentTarget.src !== logoSrc) {
                  e.currentTarget.src = logoSrc;
                }
              }
            })
          })
        }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-4 text-center text-xs font-normal tracking-[1px]",
          children: storeData === null || storeData === void 0 ? void 0 : storeData.name
        }), storeData !== null && storeData !== void 0 && storeData.email ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "mailto:".concat(storeData.email),
          className: "mt-1 text-center text-[11px] font-normal tracking-[1px] text-checkoutText",
          children: storeData.email
        }) : null, instagramHandle ? /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          href: "https://www.instagram.com/".concat(instagramHandle),
          target: "_blank",
          rel: "noreferrer",
          className: "mt-1 text-center text-[11px] font-normal tracking-[1px] text-checkoutText",
          children: ["@", instagramHandle]
        }) : null]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative mt-8",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex flex-col items-start gap-4",
          children: footerLinks.map(function (item) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: item.href,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: "m-0 inline-block w-fit text-[11px] font-normal tracking-[1px] text-checkoutText",
                children: item.label
              })
            }, item.href);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "button",
          "aria-label": "Back to top",
          className: "absolute bottom-0 right-0 z-10 flex h-8 w-8 cursor-pointer items-end justify-end border-0 bg-transparent p-0",
          onClick: scrollToTop,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Footer_BackToTopSvg, {})
        })]
      })]
    })]
  });
};

/* harmony default export */ var Footer_FeaturedFooter = (FeaturedFooter);
;// CONCATENATED MODULE: ./components/Footer/Footer.jsx



var Footer = function Footer() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Footer_FeaturedFooter, {});
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 7103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StaticInfoBanner; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5271);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4941);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2676);



function StaticInfoBanner(_ref) {
  var text = _ref.text,
      className = _ref.className;
  if (!text) return null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("flex h-12 w-full max-w-[var(--max-width)] items-center justify-center bg-[var(--theme-action-fill)] px-5 py-4 text-center font-montserrat text-xs font-normal text-[var(--theme-action-text)]", className),
    children: text
  });
}

/***/ }),

/***/ 4196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _AppContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4322);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2676);

/**
 * Full-page buyer loader. CSS oval — no react-loader-spinner (defaultProps warn). `message`, when
 * given, is shown under it (e.g. while leaving for the payment page).
 */




var LoaderComponent = function LoaderComponent(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AppContainer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: "fixed inset-0 z-[95] flex flex-col items-center justify-center gap-4 px-6",
      role: "status",
      "aria-label": message || "Loading",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
        className: "inline-block h-10 w-10 animate-spin rounded-full border-[3px] border-[#ccc] border-t-transparent",
        "aria-hidden": true
      }), message ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
        className: "text-center font-montserrat text-[14px] font-medium text-checkoutText",
        children: message
      }) : null]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (LoaderComponent);

/***/ }),

/***/ 9574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2175);
/* harmony import */ var _vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2893);
/* harmony import */ var _cartIcon_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(753);
/* harmony import */ var _cartIcon_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_cartIcon_module_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2676);


var _excluded = ["filled", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var bagPath = "M4 4.5H14Q16 4.5 16 6.5V15.25Q16 17.25 14 17.25H4Q2 17.25 2 15.25V6.5Q2 4.5 4 4.5Z";

var CartIconSvg = function CartIconSvg(_ref) {
  var _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      props = (0,_vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  var stroke = 0.8;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", _objectSpread(_objectSpread({
    width: "22",
    height: "22",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    className: "".concat((_cartIcon_module_css__WEBPACK_IMPORTED_MODULE_3___default().icon), " ").concat(filled ? (_cartIcon_module_css__WEBPACK_IMPORTED_MODULE_3___default().filled) : "", " ").concat(className).trim()
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M6.25 4.5V3.5a2.75 2.75 0 0 1 5.5 0V4.5",
      className: (_cartIcon_module_css__WEBPACK_IMPORTED_MODULE_3___default().handle),
      strokeWidth: stroke,
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: bagPath,
      fill: "white"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: bagPath,
      className: (_cartIcon_module_css__WEBPACK_IMPORTED_MODULE_3___default().bagFill)
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: bagPath,
      className: (_cartIcon_module_css__WEBPACK_IMPORTED_MODULE_3___default().outline),
      strokeWidth: stroke,
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M6.5 10.75H11.5",
      className: (_cartIcon_module_css__WEBPACK_IMPORTED_MODULE_3___default().straightLine),
      strokeWidth: stroke,
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M6.25 10Q9 13.25 11.75 10",
      className: (_cartIcon_module_css__WEBPACK_IMPORTED_MODULE_3___default().smile),
      strokeWidth: stroke,
      strokeLinecap: "round"
    })]
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (CartIconSvg);

/***/ }),

/***/ 6274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Navbar; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dynamic.js
var dynamic = __webpack_require__(4869);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/router.js
var next_router = __webpack_require__(7048);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(5271);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-use-scroll-direction@0.1.0_react@18.3.1/node_modules/react-use-scroll-direction/dist/react-use-scroll-direction.esm.js
var react_use_scroll_direction_esm = __webpack_require__(6725);
// EXTERNAL MODULE: ./node_modules/.pnpm/zustand@5.0.15_@types+react@17.0.93_react@18.3.1_use-sync-external-store@1.6.0_react@18.3.1_/node_modules/zustand/esm/react/shallow.mjs + 1 modules
var shallow = __webpack_require__(3868);
// EXTERNAL MODULE: ./lib/utils.js
var utils = __webpack_require__(4941);
// EXTERNAL MODULE: ./store/cart-store.js
var cart_store = __webpack_require__(2071);
// EXTERNAL MODULE: ./store/search-store.js
var search_store = __webpack_require__(7413);
// EXTERNAL MODULE: ./components/Navbar/CartIconSvg.jsx
var CartIconSvg = __webpack_require__(9574);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2175);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2676);
;// CONCATENATED MODULE: ./components/Navbar/CloseIconSvg.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var CloseIconSvg = function CloseIconSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: props.color || "var(--color-primary)",
      d: "M.19 13.5c.264.25.684.25.941 0l5.714-5.72 5.72 5.72c.25.25.684.257.935 0a.662.662 0 0 0 0-.935l-5.714-5.72 5.714-5.72a.656.656 0 0 0 0-.935.675.675 0 0 0-.935 0l-5.72 5.72L1.131.19a.677.677 0 0 0-.94 0 .675.675 0 0 0 0 .935l5.72 5.72-5.72 5.72a.668.668 0 0 0 0 .935Z"
    })
  }));
};

/* harmony default export */ var Navbar_CloseIconSvg = (CloseIconSvg);
;// CONCATENATED MODULE: ./components/Navbar/MenuIcon.jsx



var MenuIcon = function MenuIcon(_ref) {
  var onClick = _ref.onClick,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
    type: "button",
    onClick: onClick,
    className: "relative -ml-2.5 flex h-[38px] w-[38px] shrink-0 items-center justify-center",
    "aria-label": open ? "Close side navigation menu" : "Toggle side navigation menu",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      className: "relative h-px w-[15px]",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "absolute left-0 h-px w-full bg-black transition-transform duration-300 ease-in-out ".concat(open ? "translate-y-0 rotate-45" : "-translate-y-1")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "absolute left-0 h-px w-full bg-black transition-transform duration-300 ease-in-out ".concat(open ? "translate-y-0 -rotate-45" : "translate-y-1")
      })]
    })
  });
};

/* harmony default export */ var Navbar_MenuIcon = (MenuIcon);
;// CONCATENATED MODULE: ./components/Navbar/SearchIconSvg.jsx


function SearchIconSvg_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SearchIconSvg_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SearchIconSvg_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SearchIconSvg_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SearchIconSvg = function SearchIconSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", SearchIconSvg_objectSpread(SearchIconSvg_objectSpread({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M19.4983 19.4983L15.8623 15.8623M15.8623 15.8623C19.3747 12.3499 19.3747 6.64668 15.8623 3.13429C12.3499 -0.378097 6.64668 -0.378097 3.13429 3.13429C-0.378097 6.64668 -0.378097 12.3499 3.13429 15.8623C6.64668 19.3747 12.3499 19.3747 15.8623 15.8623Z",
      stroke: "currentColor",
      strokeLinecap: "round"
    })
  }));
};

/* harmony default export */ var Navbar_SearchIconSvg = (SearchIconSvg);
;// CONCATENATED MODULE: ./components/Navbar/index.jsx















var SearchSidebar = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(885), __webpack_require__.e(5813), __webpack_require__.e(2499), __webpack_require__.e(6093), __webpack_require__.e(2070)]).then(__webpack_require__.bind(__webpack_require__, 1478));
}, {
  loading: function loading() {
    return null;
  },
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1478)];
    }
  }
});
var useIsomorphicLayoutEffect =  true ? react.useLayoutEffect : 0;

var NavBar = function NavBar(props) {
  var _props$store;

  var _useState = (0,react.useState)(""),
      direction = _useState[0],
      setDirection = _useState[1];

  var hasHydrated = (0,cart_store/* default */.Z)(function (state) {
    return state.hasHydrated;
  });
  var cartHasItems = (0,cart_store/* default */.Z)(function (state) {
    return state.products.length > 0;
  });

  var _useScrollDirection = (0,react_use_scroll_direction_esm/* useScrollDirection */.C)(),
      isScrollingUp = _useScrollDirection.isScrollingUp,
      isScrollingDown = _useScrollDirection.isScrollingDown;

  var _useStore = (0,search_store/* default */.Z)((0,shallow/* useShallow */.N)(function (state) {
    return {
      isSearchOpen: state.isSearchOpen,
      setIsSearchOpen: state.setIsSearchOpen,
      shouldSearchReopen: state.shouldSearchReopen,
      setShouldSearchReopen: state.setShouldSearchReopen
    };
  })),
      isSearchOpen = _useStore.isSearchOpen,
      setIsSearchOpen = _useStore.setIsSearchOpen,
      shouldSearchReopen = _useStore.shouldSearchReopen,
      setShouldSearchReopen = _useStore.setShouldSearchReopen;

  var searchInputRef = (0,react.useRef)(null);
  var headerRef = (0,react.useRef)(null);
  var router = (0,next_router.useRouter)();
  var _props$homePage = props.homePage,
      homePage = _props$homePage === void 0 ? false : _props$homePage,
      _props$showSearch = props.showSearch,
      showSearch = _props$showSearch === void 0 ? true : _props$showSearch,
      _props$sideNavOpen = props.sideNavOpen,
      sideNavOpen = _props$sideNavOpen === void 0 ? false : _props$sideNavOpen;
  var storeName = ((_props$store = props.store) === null || _props$store === void 0 ? void 0 : _props$store.name) || props.storeName || ""; // Re-open search when returning to the path that set shouldSearchReopen;
  // close on other route changes. Do not depend on isSearchOpen — that made
  // every manual icon-open immediately close again.

  (0,react.useEffect)(function () {
    if (shouldSearchReopen === router.asPath) {
      setIsSearchOpen(true);
    } else {
      setIsSearchOpen(false);
    }
  }, [router.asPath, shouldSearchReopen, setIsSearchOpen]);
  (0,react.useEffect)(function () {
    isScrollingDown && setDirection("down");
    isScrollingUp && setDirection("up");
  }, [isScrollingDown, isScrollingUp]);
  useIsomorphicLayoutEffect(function () {
    if (!isSearchOpen && !sideNavOpen) return;
    var header = headerRef.current;
    if (!header) return;
    var bottom = header.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty("--store-chrome-bottom", "".concat(bottom, "px"));
  }, [isSearchOpen, sideNavOpen]);
  (0,react.useEffect)(function () {
    document.body.style.overflow = isSearchOpen || sideNavOpen ? "hidden" : "";
    return function () {
      document.body.style.overflow = "";
    };
  }, [isSearchOpen, sideNavOpen]);

  var checkoutShouldHide = function checkoutShouldHide() {
    if ( true && window.scrollY > 120) {
      return true;
    }

    return false;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("header", {
      ref: headerRef,
      className: homePage ? (0,utils.cn)("sticky top-0 z-50 flex h-[60px] w-full items-center bg-background font-montserrat transition-[top,opacity] duration-300", !isSearchOpen && !sideNavOpen && direction === "down" && checkoutShouldHide() ? "-top-16 opacity-0" : "top-0 opacity-100") : (0,utils.cn)("fixed left-1/2 top-0 z-[99] mb-5 flex h-[60px] w-full max-w-[var(--max-width)] -translate-x-1/2 items-center bg-background font-montserrat transition-[top,opacity] duration-300 ease-in-out", !isSearchOpen && !sideNavOpen && direction === "down" && checkoutShouldHide() ? "-top-[60px]" : ""),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mx-auto flex h-full w-full max-w-[var(--max-width)] items-center gap-4 px-5",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Navbar_MenuIcon, {
          open: sideNavOpen,
          onClick: function onClick() {
            var _props$toggleSideNav;

            if (isSearchOpen) {
              setShouldSearchReopen(null);
              setIsSearchOpen(false);
            }

            (_props$toggleSideNav = props.toggleSideNav) === null || _props$toggleSideNav === void 0 ? void 0 : _props$toggleSideNav.call(props);
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "min-w-0 flex-1 cursor-pointer truncate text-[15px] font-semibold text-checkoutText",
          onClick: function onClick() {
            return router.push("/");
          },
          children: storeName
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex shrink-0 items-center gap-4",
          children: [showSearch && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "button",
            className: "flex h-5 w-5 cursor-pointer items-center justify-center text-checkoutText",
            "aria-label": isSearchOpen ? "Close search menu" : "Open search menu",
            onClick: function onClick() {
              var _props$toggleSideNav2;

              if (isSearchOpen) {
                setShouldSearchReopen(null);
                setIsSearchOpen(false);
                return;
              }

              if (sideNavOpen) (_props$toggleSideNav2 = props.toggleSideNav) === null || _props$toggleSideNav2 === void 0 ? void 0 : _props$toggleSideNav2.call(props);
              setIsSearchOpen(true);
              if (searchInputRef.current) searchInputRef.current.focus();
            },
            children: isSearchOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar_CloseIconSvg, {
              color: "currentColor"
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar_SearchIconSvg, {})
          }), !props.hideInAdvance && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "button",
            className: "-mr-2.5 mb-0.5 flex h-[38px] w-[38px] cursor-pointer items-center justify-center",
            "aria-label": "Open cart",
            onClick: function onClick() {
              var _props$toggleSideNav3, _props$handleShowCart;

              if (sideNavOpen) (_props$toggleSideNav3 = props.toggleSideNav) === null || _props$toggleSideNav3 === void 0 ? void 0 : _props$toggleSideNav3.call(props);

              if (isSearchOpen) {
                setShouldSearchReopen(null);
                setIsSearchOpen(false);
              }

              (_props$handleShowCart = props.handleShowCart) === null || _props$handleShowCart === void 0 ? void 0 : _props$handleShowCart.call(props, true);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CartIconSvg/* default */.Z, {
              filled: hasHydrated && cartHasItems
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SearchSidebar, {
      isOpen: isSearchOpen,
      toggleDrawer: function toggleDrawer() {
        return setIsSearchOpen(!isSearchOpen);
      },
      store: props.store,
      searchRef: searchInputRef
    })]
  });
};

/* harmony default export */ var Navbar = (NavBar);

/***/ }),

/***/ 8122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2676);

/**
 * <picture> with AVIF sources and a universal 512 WebP <img>, driven by a `resolveImage()` result.
 * On load error it steps through `resolved.fallbacks` (today's URL, then the raw legacy string)
 * instead of re-pinning straight to S3.
 *
 * Only rendered when `resolved.isV2` is true; components keep their existing markup otherwise, so
 * turning the flag off restores today's DOM exactly.
 */




var Picture = function Picture(_ref) {
  var _resolved$fallbacks, _resolved$sources;

  var resolved = _ref.resolved,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? "" : _ref$alt,
      className = _ref.className,
      imgClassName = _ref.imgClassName,
      style = _ref.style,
      width = _ref.width,
      height = _ref.height,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? "lazy" : _ref$loading,
      fetchpriority = _ref.fetchpriority,
      _ref$decoding = _ref.decoding,
      decoding = _ref$decoding === void 0 ? "async" : _ref$decoding,
      onLoad = _ref.onLoad,
      onClick = _ref.onClick,
      draggable = _ref.draggable;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(-1),
      step = _useState[0],
      setStep = _useState[1]; // -1 = primary, 0.. = fallbacks


  var srcRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(resolved === null || resolved === void 0 ? void 0 : resolved.src);
  var imgRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null); // Reset the fallback chain *during* render, not in an effect: carousel slides (key={index}) and
  // list items reuse this instance for a different image, and a post-render reset would leave the
  // first render on the previous image's fallback — or on `undefined` when the new chain is
  // shorter. React re-renders with the new state before committing this one.

  var current = step;

  if (srcRef.current !== (resolved === null || resolved === void 0 ? void 0 : resolved.src)) {
    srcRef.current = resolved === null || resolved === void 0 ? void 0 : resolved.src;
    current = -1;
    if (step !== -1) setStep(-1);
  }

  var stepRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(current);
  stepRef.current = current;
  var hasImage = !!(resolved && resolved.src);
  var usingFallback = current >= 0;
  var src = !hasImage ? undefined : usingFallback ? (_resolved$fallbacks = resolved.fallbacks) === null || _resolved$fallbacks === void 0 ? void 0 : _resolved$fallbacks[current] : resolved.src; // An error that fired before React attached onError (e.g. carousel clones, hydration) is
  // otherwise lost: a complete image with no pixels means the primary candidate failed. This can
  // only happen for the candidate the element mounts with — once React has attached onError, that
  // handler owns every later failure — so it runs once per image, on the primary only. Without
  // that bound (and without a dependency array) it re-fired on every ancestor render and burned
  // the whole chain on any zero-pixel image that had not actually errored.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!src || stepRef.current !== -1) return;
    var el = imgRef.current;

    if (el && el.complete && el.naturalWidth === 0 && ((resolved === null || resolved === void 0 ? void 0 : resolved.fallbacks) || []).length > stepRef.current + 1) {
      setStep(stepRef.current + 1);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [src]);
  if (!hasImage) return null;

  var onError = function onError() {
    var next = stepRef.current + 1;
    if (next < (resolved.fallbacks || []).length) setStep(next);
  };

  var img = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
    ref: imgRef,
    src: src,
    alt: alt,
    className: imgClassName || className,
    style: style,
    width: width || resolved.width,
    height: height || resolved.height,
    sizes: !usingFallback ? resolved.sizes : undefined,
    loading: loading,
    decoding: decoding // React 18 warns on camelCase for this attribute; lowercase reaches the DOM as-is.
    ,
    fetchpriority: fetchpriority,
    onLoad: onLoad,
    onError: onError,
    onClick: onClick,
    draggable: draggable
  }); // Once we are on a fallback, drop the AVIF sources too: the browser would otherwise keep
  // choosing a <source> and never use the fallback <img src>.


  if (usingFallback || !((_resolved$sources = resolved.sources) !== null && _resolved$sources !== void 0 && _resolved$sources.length)) return img;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("picture", {
    className: imgClassName ? className : undefined,
    children: [resolved.sources.map(function (s) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
        type: s.type,
        srcSet: s.srcSet,
        sizes: s.sizes
      }, s.type);
    }), img]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Picture);

/***/ }),

/***/ 5538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SideNavDrawer; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/router.js
var next_router = __webpack_require__(7048);
// EXTERNAL MODULE: ./hooks/useStorefrontCollections.js
var useStorefrontCollections = __webpack_require__(1126);
// EXTERNAL MODULE: ./lib/collectionUrls.js
var collectionUrls = __webpack_require__(3874);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/link.js
var next_link = __webpack_require__(153);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/tailwind-merge@3.6.0/node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(3358);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2676);
;// CONCATENATED MODULE: ./components/LinkItem.jsx




var LinkItem = function LinkItem(_ref) {
  var href = _ref.href,
      label = _ref.label,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: href,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: (0,bundle_mjs/* twMerge */.m6)("m-0 opacity-100", className),
      children: label
    })
  });
};

/* harmony default export */ var components_LinkItem = (LinkItem);
;// CONCATENATED MODULE: ./components/SideNavDrawer.jsx







var SideNavDrawer = function SideNavDrawer(_ref) {
  var isOpen = _ref.isOpen,
      toggleDrawer = _ref.toggleDrawer;
  var router = (0,next_router.useRouter)();

  var _useStorefrontCollect = (0,useStorefrontCollections/* default */.Z)(),
      collectionsData = _useStorefrontCollect.data,
      isCollectionsLoading = _useStorefrontCollect.isLoading,
      collectionsError = _useStorefrontCollect.error;

  var collections = (collectionsData === null || collectionsData === void 0 ? void 0 : collectionsData.collections) || [];
  if (collectionsError) return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: "Error loading collections"
  });

  var onClickItem = function onClickItem(path) {
    router.push(path);
    toggleDrawer();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("aside", {
    className: "fixed left-1/2 z-40 w-full max-w-app overflow-y-auto bg-background pb-[env(safe-area-inset-bottom,0px)] font-montserrat transition-transform duration-500 ease-in-out ".concat(isOpen ? "-translate-x-1/2" : "pointer-events-none -translate-x-[calc(100%+50vw)]"),
    style: {
      top: "var(--store-chrome-bottom, 60px)",
      height: "calc(100dvh - var(--store-chrome-bottom, 60px))"
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
      className: "mt-4",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        className: "ml-0 flex w-full flex-col gap-y-2",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "w-full",
          onClick: function onClick() {
            return toggleDrawer();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_LinkItem, {
            href: "/collections/all",
            label: "Shop All",
            className: "block w-full px-5 text-[20px] font-medium text-checkoutText"
          })
        }), !isCollectionsLoading && collections.map(function (collection) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "w-full",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "block w-full cursor-pointer break-words px-5 text-[20px] font-medium text-checkoutText",
              onClick: function onClick() {
                return onClickItem((0,collectionUrls/* collectionPath */.vd)(collection));
              },
              children: collection.title
            })
          }, collection.id);
        })]
      })
    })
  });
};

/* harmony default export */ var components_SideNavDrawer = (SideNavDrawer);

/***/ }),

/***/ 1126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4697);
/* harmony import */ var _vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1260);
/* harmony import */ var _vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3805);
/* harmony import */ var _services_frontend_storefront_apis__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5666);




/** Normalize the storefront collection title, handle and id for chips / side nav. */

var normalizeCollections = function normalizeCollections(data) {
  return {
    collections: ((data === null || data === void 0 ? void 0 : data.collections) || []).map(function (c) {
      return {
        _id: c.id,
        id: c.id,
        title: c.title,
        handle: c.handle || null
      };
    })
  };
};

var useStorefrontCollections = function useStorefrontCollections() {
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)({
    queryKey: ["storefrontCollections"],
    queryFn: function () {
      var _queryFn = (0,_vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,_services_frontend_storefront_apis__WEBPACK_IMPORTED_MODULE_1__/* .getStorefrontCollections */ .Bl)();

              case 2:
                data = _context.sent;
                return _context.abrupt("return", normalizeCollections(data));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function queryFn() {
        return _queryFn.apply(this, arguments);
      }

      return queryFn;
    }(),
    cacheTime: 30 * 1000,
    staleTime: 30 * 1000
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (useStorefrontCollections);

/***/ }),

/***/ 2797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3805);
/* harmony import */ var _services_frontend_storefront_apis__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5666);



var useStorefrontLegal = function useStorefrontLegal(enabled) {
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)({
    queryKey: ["storefrontLegal"],
    queryFn: _services_frontend_storefront_apis__WEBPACK_IMPORTED_MODULE_0__/* .getStorefrontLegal */ .eg,
    enabled: enabled,
    staleTime: 30 * 1000
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (useStorefrontLegal);

/***/ }),

/***/ 351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V$": function() { return /* binding */ toCdnUrl; },
/* harmony export */   "b0": function() { return /* binding */ getCdnHost; }
/* harmony export */ });
/* unused harmony exports isS3MetaUrl, isMediaBucketUrl */
/* provided dependency */ var process = __webpack_require__(6964);
/* global process, URL */
var S3_META_HOST = "shop-meta.s3.ap-south-1.amazonaws.com"; // New media bucket (dayzero account). Old-field URLs from new uploads point
// here (img/<id>/v1/512.webp). Configurable so a staging bucket can be swapped
// in without a code change.

var MEDIA_BUCKET_HOST = (process.env.NEXT_PUBLIC_MEDIA_BUCKET_HOST || "sh0p-media.s3.ap-south-1.amazonaws.com").replace(/^https?:\/\//, "").replace(/\/$/, "");
var S3_MEDIA_HOSTS = [S3_META_HOST, MEDIA_BUCKET_HOST];

var isCdnEnabled = function isCdnEnabled() {
  return "true" === "true";
};

var getCdnHost = function getCdnHost() {
  return ("d2iai535y0ceb2.cloudfront.net" || 0).replace(/^https?:\/\//, "").replace(/\/$/, "");
};

var isS3MediaHost = function isS3MediaHost(hostname) {
  return S3_MEDIA_HOSTS.includes(hostname) || hostname.includes("shop-meta.s3") || hostname.includes("sh0p-media.s3");
};

var isS3MetaUrl = function isS3MetaUrl(url) {
  if (!url) return false;

  try {
    var _URL = new URL(url),
        hostname = _URL.hostname;

    return isS3MediaHost(hostname);
  } catch (_unused) {
    return typeof url === "string" && (url.includes("shop-meta.s3") || url.includes("sh0p-media.s3"));
  }
};
/** URLs on the new media bucket are also served by the same CloudFront distribution (/img/*, /raw/*). */

var isMediaBucketUrl = function isMediaBucketUrl(url) {
  if (!url) return false;

  try {
    return new URL(url).hostname === MEDIA_BUCKET_HOST;
  } catch (_unused2) {
    return typeof url === "string" && url.includes(MEDIA_BUCKET_HOST);
  }
};
/** Rewrite shop-meta / media-bucket S3 URLs to CloudFront when the flag is on. Other hosts unchanged. */

var toCdnUrl = function toCdnUrl(url) {
  if (!url || !isCdnEnabled()) return url;
  var cdnHost = getCdnHost();
  if (!cdnHost || !(isS3MetaUrl(url) || isMediaBucketUrl(url))) return url;

  try {
    var parsed = new URL(url);
    parsed.protocol = "https:";
    parsed.host = cdnHost;
    return parsed.toString();
  } catch (_unused3) {
    return url;
  }
};

/***/ }),

/***/ 3874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dz": function() { return /* binding */ findCollectionByHandle; },
/* harmony export */   "vd": function() { return /* binding */ collectionPath; }
/* harmony export */ });
/* unused harmony export ALL_COLLECTIONS_HANDLE */
/**
 * Collection URLs are /collections/<handle>. The handle is stored on the collection (generated
 * from its name, unique per store, unchanged by a rename), so links never depend on the title.
 * The backend resolves old URLs (edited handles, the pre-handle "%20" name URL) and answers
 * with a redirect to the canonical handle.
 */

/** Reserved: the all-products listing. A collection named "All" has a handle like `all-1`. */
var ALL_COLLECTIONS_HANDLE = "all";
/**
 * Link for a collection (`{ handle, title }`). A collection without a handle (not yet
 * backfilled) links by its trimmed title, which the backend still resolves and redirects.
 */

var collectionPath = function collectionPath(collection) {
  var handle = collection === null || collection === void 0 ? void 0 : collection.handle;
  if (handle) return "/collections/".concat(encodeURIComponent(handle));
  var title = String((collection === null || collection === void 0 ? void 0 : collection.title) || (collection === null || collection === void 0 ? void 0 : collection.name) || "").trim();
  return title ? "/collections/".concat(encodeURIComponent(title)) : "/collections/".concat(ALL_COLLECTIONS_HANDLE);
};
/** The listed collection a /collections/<handle> URL names, if it is in the list (exact handle). */

var findCollectionByHandle = function findCollectionByHandle(collections, handle) {
  if (!handle) return null;
  return (collections || []).find(function (collection) {
    return (collection === null || collection === void 0 ? void 0 : collection.handle) === handle;
  }) || null;
};

/***/ }),

/***/ 1485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qf": function() { return /* binding */ ogImage; },
/* harmony export */   "rs": function() { return /* binding */ resolveImage; }
/* harmony export */ });
/* unused harmony exports isMediaV2Enabled, SLOTS, legacyUrl */
/* harmony import */ var _cdn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(351);
/* global process, URL */

/**
 * Image resolver for the media pipeline (see s3-costing/IMAGE_MIGRATION_PLAN.md §2.6).
 *
 * Every entity that has an image field also has a `*V2` field with entries
 *   { src, key, w, h, status, url? }
 * joined to the stored URL by `src`. When an entry is `ready` and the flag is on, we render
 * pre-generated variants from CloudFront:
 *   <CDN>/<key>/256.avif  <CDN>/<key>/512.avif  <CDN>/<key>/512.webp  <CDN>/<key>/orig.avif
 * Otherwise we return today's URL via toCdnUrl (S3 → CloudFront when enabled).
 */

var isMediaV2Enabled = function isMediaV2Enabled() {
  return "true" === "true";
};

var cdnBase = function cdnBase() {
  var host = (0,_cdn__WEBPACK_IMPORTED_MODULE_0__/* .getCdnHost */ .b0)();
  return host ? "https://".concat(host) : "";
};
/**
 * Per-slot candidate lists. Browsers pick a candidate by CSS size × device pixel ratio, so the
 * grid never offers `orig` (a 3× phone would otherwise fetch the full image for a thumbnail).
 */


var SLOTS = {
  // Product tile and featured-collection card share a box: `calc(50vw - 33px)` under the 768px
  // breakpoint, then a fixed `calc(520px/2 - 33px)` = 227px once the 520px container caps out.
  // Declaring the real box (not a viewport fraction) is what keeps the pick stable: 512 for every
  // DPR above 1, and 256 only on a genuinely low-DPR screen, where 256 physical px already covers
  // the box. A viewport fraction made the choice track window width on desktop even though the
  // tile never changes size.
  grid: {
    sizes: "(max-width: 768px) calc(50vw - 33px), 227px",
    avif: [512, 256]
  },
  // Collection-home / similar-products tile: `var(--max-width)/1.5 - 50px` = 297px at every width.
  gridWide: {
    sizes: "297px",
    avif: [512, 256]
  },
  pdp: {
    sizes: "(max-width: 768px) 100vw, 480px",
    avif: [512, "orig"]
  },
  cart: {
    sizes: "96px",
    avif: [256]
  },
  logo: {
    sizes: "120px",
    avif: [256]
  },
  hero: {
    sizes: "100vw",
    avif: [512, "orig"]
  },
  sidebar: {
    sizes: "70px",
    avif: [256]
  },
  collection: {
    sizes: "(max-width: 768px) calc(50vw - 33px), 227px",
    avif: [512, 256]
  },
  review: {
    sizes: "250px",
    avif: [512]
  }
};
/** Non-V2 URL for a slot: S3 → CDN when enabled; otherwise the stored string. */

function legacyUrl(src) {
  if (!src) return src;
  return (0,_cdn__WEBPACK_IMPORTED_MODULE_0__/* .toCdnUrl */ .V$)(src);
}

var findV2 = function findV2(src, v2) {
  if (!src || !v2) return null;
  if (Array.isArray(v2)) return v2.find(function (m) {
    return m && m.src === src && m.status === "ready" && m.key;
  });
  return v2.src === src && v2.status === "ready" && v2.key ? v2 : null;
};
/**
 * `w`/`h` are optional in the backend schema, so a `ready` entry can arrive without them. Every
 * width descriptor would then be `0w`, which invalidates the whole AVIF srcSet (the browser drops
 * the candidates and skips the <source>) and leaves width/height unset, losing the layout-shift
 * reservation. Such an entry is not usable as V2: fall back to today's URL instead.
 */


var hasDimensions = function hasDimensions(entry) {
  return Number.isFinite(entry === null || entry === void 0 ? void 0 : entry.w) && entry.w > 0 && Number.isFinite(entry === null || entry === void 0 ? void 0 : entry.h) && entry.h > 0;
};
/**
 * Resolve one image for a slot.
 * @param {string} src            the stored URL (value of photos[i], store.logo, ...)
 * @param {Array|Object} v2       the matching *V2 field (array for lists, object for singles)
 * @param {keyof SLOTS} slot
 * @returns {{ isV2: boolean, src: string, fallbacks: string[], sources?: Array, width?: number, height?: number, sizes?: string }}
 *   `src` is what goes in <img src>; `fallbacks` are tried in order by the onError handler.
 */


function resolveImage(src, v2) {
  var slot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "grid";
  var cfg = SLOTS[slot] || SLOTS.grid;
  var entry = isMediaV2Enabled() ? findV2(src, v2) : null;
  var base = cdnBase();

  if (entry && base && hasDimensions(entry)) {
    var u = function u(name) {
      return "".concat(base, "/").concat(entry.key, "/").concat(name);
    };

    var w = entry.w;
    var h = entry.h;
    var L = Math.max(w, h); // width descriptor = the variant's real width (256/512 are long-edge caps; portrait 1080×1440 → 384w)

    var widthOf = function widthOf(t) {
      return t === "orig" ? w : Math.round(Math.min(t, L) * w / L);
    };

    return {
      isV2: true,
      src: u("512.webp"),
      width: w,
      height: h,
      sizes: cfg.sizes,
      sources: [{
        type: "image/avif",
        srcSet: cfg.avif.map(function (t) {
          return "".concat(u("".concat(t, ".avif")), " ").concat(widthOf(t), "w");
        }).join(", "),
        sizes: cfg.sizes
      }],
      // if the CDN variant fails (or the browser decodes neither AVIF nor WebP), fall back to
      // today's URL, then the raw stored string: both are the original image for every source
      fallbacks: [legacyUrl(src), src].filter(function (x, i, arr) {
        return x && x !== u("512.webp") && arr.indexOf(x) === i;
      })
    };
  }

  var legacy = legacyUrl(src);
  return {
    isV2: false,
    src: legacy,
    fallbacks: legacy !== src ? [src] : []
  };
}
/**
 * og:image for link previews. Crawlers do not negotiate AVIF; 512.webp is accepted by Meta and
 * WhatsApp. Falls back to today's CDN URL of the original.
 */

function ogImage(src, v2) {
  if (!src) return src;
  var entry = isMediaV2Enabled() ? findV2(src, v2) : null;
  var base = cdnBase();
  if (entry && base) return "".concat(base, "/").concat(entry.key, "/512.webp");
  if (src.startsWith("//")) return "https:".concat(src);
  return (0,_cdn__WEBPACK_IMPORTED_MODULE_0__/* .toCdnUrl */ .V$)(src);
}

/***/ }),

/***/ 4941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ cn; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2159);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3358);


function cn() {
  for (var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++) {
    inputs[_key] = arguments[_key];
  }

  return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_0__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .W)(inputs));
}

/***/ }),

/***/ 3726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ getPrice; },
/* harmony export */   "w": function() { return /* binding */ truncateTo2Decimals; }
/* harmony export */ });
/* harmony import */ var _utils_order_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1189);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

 // Founder sheet, new sh0p rate incl. GST %. No flat ₹1 on these.

var serviceChargeMapping = {
  cc: function cc(deliveryOption) {
    return (deliveryOption === null || deliveryOption === void 0 ? void 0 : deliveryOption.key) === "international" ? 4.99 : 3.2;
  },
  dc: function dc(price, deliveryOption) {
    return (deliveryOption === null || deliveryOption === void 0 ? void 0 : deliveryOption.key) === "international" ? 4.99 : price > 2000 ? 2.28 : 2;
  },
  upi: 2.18,
  app: 2.98,
  nb: 2.93,
  bnpl: 5.0
};

var truncateTo2Decimals = function truncateTo2Decimals(num) {
  if (num == null) return null;
  return Math.floor(num * 100) / 100;
};

var getApplicableProcessingFee = function getApplicableProcessingFee(processingFee, storePaysProcessingFee) {
  if (storePaysProcessingFee) {
    return 0;
  }

  return processingFee;
};

var getPrice = function getPrice(deliveryOption, cart) {
  var paymentMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var storePaysProcessingFee = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var partialPaymentPercentage = deliveryOption === null || deliveryOption === void 0 ? void 0 : deliveryOption.partialPaymentPercentage;
  var calculatedPrice = 0;
  var shippingFeeApplied = false;
  var shippingFee = deliveryOption === null || deliveryOption === void 0 ? void 0 : deliveryOption.shippingCharge;
  var discountedAmount = cart === null || cart === void 0 ? void 0 : cart.discountedAmount;
  var couponId, couponCode;
  var partialPaymentPrice = null;

  if (discountedAmount) {
    couponId = cart.couponId;
    couponCode = cart.couponCode;
  }

  var actualShippingFee = cart.shippingFee;
  var shippingFeeCap = Number.isInteger(cart.shippingFeeCap) ? cart.shippingFeeCap : Number.MAX_SAFE_INTEGER;

  var _iterator = _createForOfIteratorHelper(cart.products),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var product = _step.value;
      var productQuantity = product.quantity ? product.quantity : 1;
      calculatedPrice += product.salePrice * productQuantity;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var priceWithoutFees = calculatedPrice;

  if (discountedAmount) {
    calculatedPrice = priceWithoutFees - discountedAmount;
  }

  if (calculatedPrice < shippingFeeCap) {
    calculatedPrice += shippingFee ? shippingFee : 0;
    shippingFeeApplied = true;
  } else {
    shippingFee = 0;
  }

  var productTotalPrice = calculatedPrice;
  var processingFee = 0;

  if ((0,_utils_order_util__WEBPACK_IMPORTED_MODULE_0__/* .isCODWithoutPartialPayment */ .D)(deliveryOption)) {
    processingFee = 0;
  } else if (paymentMode === "dc") {
    processingFee = Number((calculatedPrice * (serviceChargeMapping[paymentMode](calculatedPrice, deliveryOption) / 100)).toFixed(2));
  } else if (paymentMode === "cc") {
    processingFee = Number((calculatedPrice * (serviceChargeMapping[paymentMode](deliveryOption) / 100)).toFixed(2));
  } else if (paymentMode) {
    var serviceCharge = serviceChargeMapping[paymentMode];

    if (typeof serviceCharge === "function") {
      processingFee = Number((calculatedPrice * (serviceCharge(calculatedPrice) / 100)).toFixed(2));
    } else {
      processingFee = Number((calculatedPrice * (serviceCharge / 100)).toFixed(2));
    }
  } else {
    processingFee = Number((calculatedPrice * 0.02).toFixed(2));
  }

  if ((0,_utils_order_util__WEBPACK_IMPORTED_MODULE_0__/* .isCODWithoutPartialPayment */ .D)(deliveryOption) || !paymentMode || paymentMode === "bnpl") {
    processingFee += 1;
  }

  var pricewithShipping = calculatedPrice;
  calculatedPrice += getApplicableProcessingFee(processingFee, storePaysProcessingFee);

  if (partialPaymentPercentage) {
    partialPaymentPrice = pricewithShipping * (partialPaymentPercentage / 100) + getApplicableProcessingFee(processingFee, storePaysProcessingFee);
  }

  calculatedPrice = calculatedPrice != 0 ? calculatedPrice.toFixed(2) : calculatedPrice;
  return {
    productTotalPrice: productTotalPrice,
    total: calculatedPrice,
    shippingFee: shippingFee,
    shippingFeeCap: shippingFeeCap,
    actualShippingFee: actualShippingFee,
    paymentProcessingFee: processingFee,
    shippingFeeApplied: shippingFeeApplied,
    priceWithoutFees: priceWithoutFees,
    couponId: couponId,
    couponCode: couponCode,
    partialPaymentPrice: partialPaymentPrice
  };
};


/*
 * Old buyer fee (Cashfree-era). Not what this file charges anymore.
 * Restore this if checkout is switched back. Flat ₹1 was added after every %.
 * No GST line on these %. Buyer pays unless the store pays the fee itself.
 *
 *   UPI base ≤ ₹600                          2.18% + ₹1
 *   UPI base > ₹600, cohort includes 5       2.00% + ₹1
 *   UPI base > ₹600, no cohort 5             1.75% + ₹1
 *   Netbanking (all banks)                   2.93% + ₹1
 *   Debit domestic ≤ ₹2,000                  2.00% + ₹1
 *   Debit domestic > ₹2,000                  2.28% + ₹1
 *   Debit, international delivery            4.99% + ₹1
 *   Credit domestic                          3.03% + ₹1
 *   Credit, international delivery           4.99% + ₹1
 *   Wallets                                  2.98% + ₹1
 *   Pay later                                5.00% + ₹1
 *   No method chosen                         2% + ₹1
 *   Full COD, no partial                     ₹1
 */

/***/ }),

/***/ 2071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7007);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(380);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3161);



var STORAGE_KEY = "sh0p.cart";

var isCurrentCartProduct = function isCurrentCartProduct(product) {
  if (!product || typeof product !== "object") return false;
  var hasLegacyProductKeys = ["name", "price", "mrp", "stock", "variants", "photosV2", "customisations", "headerPhoto"].some(function (key) {
    return Object.prototype.hasOwnProperty.call(product, key);
  });
  var hasLegacyOptionKeys = !Array.isArray(product.options) || product.options.some(function (option) {
    return !option || ["name", "price", "stock"].some(function (key) {
      return Object.prototype.hasOwnProperty.call(option, key);
    });
  });
  var hasLegacyCollectionKeys = !Array.isArray(product.collections) || product.collections.some(function (collection) {
    return !collection || Object.prototype.hasOwnProperty.call(collection, "name");
  });
  return !hasLegacyProductKeys && !hasLegacyOptionKeys && !hasLegacyCollectionKeys && typeof product.title === "string" && Object.prototype.hasOwnProperty.call(product, "salePrice") && Array.isArray(product.photos) && Array.isArray(product.options) && Array.isArray(product.collections);
};

var useCart = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .U)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .persist */ .tJ)(function (set, get) {
  return {
    products: [],
    discountedAmount: undefined,
    couponId: undefined,
    couponCode: undefined,
    hasHydrated: false,
    setHasHydrated: function setHasHydrated(hasHydrated) {
      return set({
        hasHydrated: hasHydrated
      });
    },

    /** Full cart object for existing UI (`{ products, discountedAmount?, ... }`). */
    getCart: function getCart() {
      var s = get();
      var cart = {
        products: s.products
      };

      if (s.discountedAmount != null) {
        cart.discountedAmount = s.discountedAmount;
        cart.couponId = s.couponId;
        cart.couponCode = s.couponCode;
      }

      return cart;
    },
    setCart: function setCart(cartData) {
      if (!cartData) return;
      set({
        products: Array.isArray(cartData.products) ? (0,_vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(cartData.products) : [],
        discountedAmount: cartData.discountedAmount,
        couponId: cartData.couponId,
        couponCode: cartData.couponCode
      });
    },
    applyPromoCode: function applyPromoCode(discountedAmount, couponId, couponCode) {
      return set({
        discountedAmount: discountedAmount,
        couponId: couponId,
        couponCode: couponCode
      });
    },
    removePromoCode: function removePromoCode() {
      return set({
        discountedAmount: undefined,
        couponId: undefined,
        couponCode: undefined
      });
    },
    clearCart: function clearCart() {
      return set({
        products: [],
        discountedAmount: undefined,
        couponId: undefined,
        couponCode: undefined
      });
    }
  };
}, {
  name: STORAGE_KEY,
  storage: (0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .createJSONStorage */ .FL)(function () {
    return localStorage;
  }),
  partialize: function partialize(state) {
    return {
      products: state.products
    };
  }
}));

function markHydrated() {
  var state = useCart.getState();

  if (!Array.isArray(state.products) || state.products.some(function (product) {
    return !isCurrentCartProduct(product);
  })) {
    state.clearCart();
    useCart.persist.clearStorage();
  }

  useCart.setState({
    hasHydrated: true
  });
}

if (true) {
  useCart.persist.onFinishHydration(markHydrated); // Rehydration may finish before this subscriber is attached.

  Promise.resolve().then(function () {
    if (useCart.persist.hasHydrated()) markHydrated();
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (useCart);

/***/ }),

/***/ 7413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(380);
// TODO(cleanup): rename export to useSearchStore; drop unused fields; match cart-store style.
// Object selectors at call sites must use useShallow (zustand v5).

var useStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .U)(function (set) {
  return {
    data: null,
    scrollPosition: 0,
    setScrollPosition: function setScrollPosition(position) {
      return set({
        scrollPosition: position
      });
    },
    setData: function setData(data) {
      return set({
        data: data
      });
    },
    searchQuery: "",
    lastTrackedQuery: "",
    setSearchQuery: function setSearchQuery(query) {
      return set({
        searchQuery: query,
        scrollPosition: 0
      });
    },
    isSearchOpen: false,
    setIsSearchOpen: function setIsSearchOpen(isSearchOpen) {
      set({
        isSearchOpen: isSearchOpen
      });
    },
    shouldSearchReopen: false,
    setShouldSearchReopen: function setShouldSearchReopen(shouldSearchReopen) {
      set({
        shouldSearchReopen: shouldSearchReopen
      });
    },
    setLastTrackedQuery: function setLastTrackedQuery(query) {
      return set({
        lastTrackedQuery: query
      });
    }
  };
});
/* harmony default export */ __webpack_exports__["Z"] = (useStore);

/***/ }),

/***/ 1189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ isCODWithoutPartialPayment; },
/* harmony export */   "T": function() { return /* binding */ cartRequiresShipping; }
/* harmony export */ });
var isCODWithoutPartialPayment = function isCODWithoutPartialPayment(deliveryOption) {
  return deliveryOption.key === "cod" && deliveryOption.partialPaymentPercentage === undefined;
}; // One physical item is enough: the order ships as one unit. Products from before the flag existed
// (no `requiresShipping`) ship. The backend re-checks this from the product records.

var cartRequiresShipping = function cartRequiresShipping(cart) {
  return ((cart === null || cart === void 0 ? void 0 : cart.products) || []).some(function (product) {
    return product.requiresShipping !== false;
  });
};

/***/ }),

/***/ 753:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon":"cartIcon_icon__rRcnz","handle":"cartIcon_handle__bAPOc","outline":"cartIcon_outline__lehV3","straightLine":"cartIcon_straightLine__fVfE_","bagFill":"cartIcon_bagFill__CRJVK","smile":"cartIcon_smile__lNM0Z","filled":"cartIcon_filled__st2jW"};

/***/ })

}]);